import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import ProductCard from "../components/ProductCard";

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const activeCat = params.get("category") || "all";
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/categories").then((r) => setCategories(r.data));
  }, []);

  useEffect(() => {
    setLoading(true);
    const url = activeCat === "all" ? "/products" : `/products?category=${activeCat}`;
    api.get(url).then((r) => {
      setProducts(r.data);
      setLoading(false);
    });
  }, [activeCat]);

  const tabs = [{ slug: "all", name: "All" }, ...categories];

  return (
    <div className="px-6 md:px-12 lg:px-20 py-14 md:py-20 fade-up" data-testid="shop-page">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="eyebrow">The Shop</span>
          <h1 className="font-serif-display text-5xl md:text-6xl mt-3 leading-tight">
            Every object, a quiet offering.
          </h1>
          <p className="mt-5 text-[var(--srishti-text-secondary)]">
            Browse our hand-picked range — reserve online, pick up at our TC Palya boutique.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-12 border-b border-[var(--srishti-border)] pb-6">
          {tabs.map((t) => {
            const active = activeCat === t.slug;
            return (
              <button
                key={t.slug}
                onClick={() => {
                  if (t.slug === "all") setParams({});
                  else setParams({ category: t.slug });
                }}
                className={`px-4 md:px-5 py-2 text-xs uppercase tracking-widest font-semibold transition-colors ${
                  active
                    ? "bg-[var(--srishti-maroon)] text-[#FDFBF7]"
                    : "text-[var(--srishti-text-secondary)] hover:text-[var(--srishti-maroon)]"
                }`}
                data-testid={`category-filter-${t.slug}`}
              >
                {t.name}
              </button>
            );
          })}
        </div>

        {loading ? (
          <p className="text-center text-[var(--srishti-text-secondary)]">Loading…</p>
        ) : products.length === 0 ? (
          <p className="text-center text-[var(--srishti-text-secondary)]">
            No pieces in this collection yet.
          </p>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-7" data-testid="products-grid">
            {products.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
